import React, {useEffect, useState} from 'react';
import {FertilizersTable} from "../components/Fertilizers/FertilizersTable";
import "../style/Fertilizers.css"
import authService from "../components/api-authorization/AuthorizeService";

const Fertilizers = () => {
    const [token, setToken] = useState('')
    useEffect(async () => {
        const token_resp = await authService.getAccessToken()
        await fetch('/api/Validator', {
            method: 'POST',
            headers: !token_resp ? {} : {'Authorization': `Bearer ${token_resp}`}
        })
        setToken(token_resp)
    }, [])
    return (token===''?<></>:
        <div id='fertilizers-page'>
            <FertilizersTable token={token} key={token}></FertilizersTable>
        </div>
    );
};

export default Fertilizers;